(function(angular) {
    angular.module('bizPartEngage').directive('bizMainMenu', bizMainMenuDirective);
    angular.module('bizPartEngage').directive('bizMenuJourney', bizMenuJourney);
    angular.module('bizPartEngage').directive('bizMenuJourneyCollection', bizMenuJourneyCollection);
    angular.module('bizPartEngage').directive('bizMenuJourneyStatus', bizMenuJourneyStatus);
    angular.module('bizPartEngage').service('bizMainMenuService', bizMainMenuService);

    bizMainMenuDirective.$inject = ["bizCore"];
    bizMenuJourney.$inject = ["bizCore"];
    bizMenuJourneyCollection.$inject = ["bizCore"];
    bizMenuJourneyStatus.$inject = ["bizCore"];
    bizMainMenuService.$inject = ["$http"];

    function bizMenuJourneyStatus(bizCoreProvider) {
        var directive = {
            restrict: "E",
            scope: {                
            },
            templateUrl: bizCoreProvider.getView('core.directives.menu.journey', "FrontEnd/Core/Directives/Views/MenuJourneyStatus.html"),
            controller: bizMenuJourneyStatusController,
            controllerAs: "vm",
            bindToController: true
        }

        bizMenuJourneyStatusController.$inject = ["$rootScope", "bizJourneyService"];

        function bizMenuJourneyStatusController($rootScope, bizJourneyService) {
            var vm = this;

            vm.Init = Init;

            vm.SetCurrentJourney = SetCurrentJourney;
            vm.GoToNextJourneyObject = GoToNextJourneyObject;
            vm.SetNextJourneyObject = SetNextJourneyObject;
            vm.CloseJourneyPanel = CloseJourneyPanel;

            vm.JourneyPanelOpen = false;

            function CloseJourneyPanel() {
                vm.JourneyPanelOpen = false;
            }

            function GoToNextJourneyObject(event) {
                event.stopPropagation();

                bizJourneyService.GoToEngageItem(vm.NextJourneyObject);
            }

            function SetCurrentJourney() {
                $rootScope.JourneysInitialized.then(() => {
                    if ($rootScope.Journeys) {
                        for (var i = 0; i < $rootScope.Journeys.length; i++) {
                            if ($rootScope.Journeys[i].IsCurrentJourney) {
                                vm.CurrentJourney = $rootScope.Journeys[i];
                            }
                        }
                    }

                    vm.SetNextJourneyObject();
                });
            }

            function SetNextJourneyObject() {
                if (vm.CurrentJourney) {
                    var nextObject;
                    for (var i = 0; i < vm.CurrentJourney.EngageObjects.length; i++) {
                        if (!nextObject && vm.CurrentJourney.EngageObjects[i].Status !== 3) {
                            nextObject = vm.CurrentJourney.EngageObjects[i];
                        }
                    }
                    vm.NextJourneyObject = nextObject;
                }
            }

            function Init() {                
                vm.SetCurrentJourney();

                $rootScope.$on('CURRENT_JOURNEY_CHANGED', (event, args) => {
                    vm.SetCurrentJourney();
                });

                $rootScope.$on('JOURNEY_OBJECT_UPDATED', (event, args) => {
                    vm.SetNextJourneyObject();
                });                
            }            

            this.$onInit = vm.Init;
        }

        return directive;
    }

    function bizMenuJourney(bizCoreProvider) {
        var directive = {
            restrict: "E",
            scope: {
                journey: "=?",
                fromCollection: "@?"
            },
            templateUrl: bizCoreProvider.getView('core.directives.menu.journey', "FrontEnd/Core/Directives/Views/MenuJourney.html"),
            controller: bizMenuJourneyController,
            controllerAs: "vm",
            bindToController: true
        }

        bizMenuJourneyController.$inject = ["$rootScope"];

        function bizMenuJourneyController($rootScope) {
            var vm = this;
            vm.Init = Init;
            vm.Round = Round;

            function Init() {

            }

            function Round(p) {
                return Math.round(p);
            }

            this.$onInit = vm.Init;
        }

        return directive;
    }

    function bizMenuJourneyCollection(bizCoreProvider) {
        var directive = {
            restrict: "E",
            scope: {
                closeFunc: "&"
            },
            templateUrl: bizCoreProvider.getView('core.directives.menu.journey', "FrontEnd/Core/Directives/Views/MenuJourneyCollection.html"),
            controller: bizMenuJourneyCollectionController,
            controllerAs: "vm",
            bindToController: true
        }

        bizMenuJourneyCollectionController.$inject = ["$rootScope", "bizJourneyService", "$state"];

        function bizMenuJourneyCollectionController($rootScope, bizJourneyService, $state) {
            var vm = this;
            vm.Init = Init;
            vm.GoToJourneyPage = GoToJourneyPage;
            vm.SetCurrentJourney = SetCurrentJourney;

            function SetCurrentJourney(id) {
                if ($rootScope.Journeys && $rootScope.Journeys.length) {
                    $rootScope.SetCurrentJourney(id, true);
                    vm.closeFunc();
                }
            }

            function GoToJourneyPage() {
                vm.closeFunc();
                $state.go("base.modules.journey");
            }

            function Init() {
                
            }

            this.$onInit = vm.Init;
        }

        return directive;
    }

    function bizMainMenuDirective(bizCoreProvider) {
        var directive = {
            restrict: "E",
            scope: {
                menuItems: "="
            },
            templateUrl: bizCoreProvider.getView('core.directives.main.menu', "FrontEnd/Core/Directives/Views/MainMenu.html"),
            controller: bizMainMenuController,
            controllerAs: "vm",
			bindToController: true
        }

        bizMainMenuController.$inject = ["$state", "$stateParams", "scrollService", "$rootScope", "bizMainMenuService", "core.users.service", "bizCoreService", "$window", "$filter"];

        function bizMainMenuController($state, $stateParams, scrollService, $rootScope, bizMainMenuService, userService, bizCoreService, $window, $filter) {
            var vm = this;
        	vm.GetItemLink = GetItemLink;
            vm.Navigate = Navigate;
            vm.IsActiveItem = IsActiveItem;
            vm.IsAnchorLink = IsAnchorLink;
            vm.HandleMenuClick = HandleMenuClick;
            vm.CurrentLocation = CurrentLocation;
            vm.Logout = Logout;
            vm.Login = Login;
            vm.ChangeCulture = ChangeCulture;
            vm.Init = Init;
            
            vm.ShowInstallPWA = ShowInstallPWA;
            vm.InstallPWA = InstallPWA;
            vm.HasInstalledPwa = false;            
            vm.ShowJourneyWidget = false;

            vm.lastScrollTop = 0;
            vm.scrollTop = 0;
            vm.scrollDirection = '';
            vm.hasSentCloseEvent = false;            

        	var objectTypeSettings = {
        		100: {
        			Name: "CMSPage",
        			State: "base.modules.cms",
        			Identifier: "id"
        		}
            };

            function Logout() {
                userService.Logout();
            }

            function Login() {
                console.log("login");
                if (vm.OpenIdProviderId) {
                    $window.location.href = $filter('siteroot')('OpenIdLogin/' + vm.OpenIdProviderId);
                }
            }

            function ChangeCulture(culture) {
                if (culture.QueryString) {
                    $window.location.href = $filter('siteroot')('/' + culture.QueryString);
                }
            }

            function HandleMenuClick(item, parentItem) {
                // Show/Hide sub-menus
                if (item.Children.length > 0) {
                    if (item.Expanded === true) {
                        item.Expanded = false;
                        return;
                    }

                    for (var i = 0; i < $rootScope.MenuItems.length; i++) {
                        $rootScope.MenuItems[i].Expanded = false;
                    }

                    item.Expanded = !item.Expanded;
                    return;
                }

                if (parentItem)
                    parentItem.Expanded = false;

                $rootScope.ExpandMainMenu = false;

                // External/http links
                if (item.Link.indexOf(window.location.hostname) > -1) {
                    window.location.href = item.Link;
                    return;
                }
                else if(item.Link.startsWith('http')) {
                    window.open(item.Link, '_blank');
                    return;
                }

                // Anchor links
                if (IsAnchorLink(item)) {

                    if (item.Link.indexOf('#') == 0) {
                        scrollService.ScrollTo($(item.Link), 0);
                    }
                    else {
                        location.href = item.Link;
                    }
                }

                return false;
            }

            function CurrentLocation() {
                return location.href.replace(location.hash, '');
            }            

            function IsActiveItem(item) {
                if(!item) return;

                var state = $state.current;

                if (typeof item === 'string') {
                    if (item == state.name || (state.data && state.data.parentState === item)) {
                        return true;
                    } else {
                        return false;
                    }
                }
                else if (item.Link == state.name ||
                    state.data !== undefined && item.Link == state.data.parentState ||
                    item.ControllerScope == state.name ||
                    state.data !== undefined && item.ControllerScope === state.data.parentState) {
                    return true;
                }
                else if (item.ObjectType == 100 && $stateParams !== undefined && $stateParams.id == item.ObjectIdentifier) {
                    return true;
                }
                else {                    
                    return false;
                }
            }

            function IsAnchorLink(item) {
                if (item.Link.indexOf('#') > -1) {
                    return true;
                }

                return false;
            }

            function GetItemLink(item) {

            	if (!item.ObjectType)
            		return item.Link;

            	var setting = objectTypeSettings[item.ObjectType];
            	if (setting) {
            		var link = String.format('{0}({{1}:"{2}"})', setting.State, setting.Identifier, item.ObjectIdentifier);
            		return link;
            	}
            }

            function Navigate(url) {
                $state.go(url);
            }

            function ShowInstallPWA() {
                if (IsPortalSettingTrue('IsPWAEnabled') && $rootScope.mobile && pwaDeferredPrompt !== undefined && !vm.HasInstalledPwa) { 
                    return true;
                }
                else {
                    return false;
                }
            }

            function InstallPWA(e) {
                vm.HasInstalledPwa = true;
                installPWA(e);
            }            

            function onScroll() {
                // only for desktop

                vm.scrollTop = $window.pageYOffset || document.documentElement.scrollTop;
                vm.scrollDirection = vm.lastScrollTop < vm.scrollTop ? 'down' : 'up';

                if (vm.scrollDirection === 'down' && vm.scrollTop > 5 && vm.hasSentCloseEvent === false) { // iOS fix 5px
                    $rootScope.ExpandMainMenu = false;
                    vm.hasSentCloseEvent = true;
                    $rootScope.$digest();
                }

                if (vm.scrollDirection === 'up') {
                    vm.hasSentCloseEvent = false;
                }

                vm.lastScrollTop = vm.scrollTop;
            }

            function Init() {
                if (IsPortalSettingTrue('IsJourneyEnabled')) {
                    vm.ShowJourneyWidget = IsPortalSettingTrue('IsJourneyMenuWidgetEnabled');
                }
                vm.ShowTipSomeone = IsPortalSettingTrue('IsShowTipSomeoneEnabled');
                vm.OpenIdProviderId = portalSettings["loginopenidp"];

                if ($rootScope.mobile === false)
                    $window.addEventListener('scroll', onScroll);
            }

            this.$onInit = vm.Init;                       
        }

        return directive;
    }

    function bizMainMenuService($http) {
        var servicePath = siteRootPath + 'api/menu/';            
    }

})(window.angular);
